// eslint-disable-next-line no-shadow
export var USER_FORM_MODE;
(function (USER_FORM_MODE) {
    USER_FORM_MODE["ADD_USER"] = "ADD_USER";
    USER_FORM_MODE["EDIT_USER"] = "EDIT_USER";
    USER_FORM_MODE["BULK_ADD"] = "BULK_ADD";
})(USER_FORM_MODE || (USER_FORM_MODE = {}));
export var ascendingOptions = [
    'Oldest to Newest',
    'A to Z',
    'Ascending',
    'Active First',
];
export var orderByOptionsMap = {
    'Date Added': ['Newest to Oldest', 'Oldest to Newest'],
    Email: ['A to Z', 'Z to A'],
    Name: ['A to Z', 'Z to A'],
    Phone: ['Ascending', 'Descending'],
    Role: ['A to Z', 'Z to A'],
    Status: ['Active First', 'Pending First'],
};
export var defaultOrderByOptions = orderByOptionsMap['Date Added'];
export var defaultSelectedOrderByOption = defaultOrderByOptions[0];
export var sortByMap = {
    Name: 'firstName',
    Email: 'email',
    Phone: 'phone',
    Role: 'role',
    Status: 'status',
    'Date Added': 'addedDate',
};
export var sortByValues = [
    'Date Added',
    'Name',
    'Email',
    'Phone',
    'Role',
    'Status',
];
export var defaultSortBy = 'Date Added';
export var defaultFilterConfig = {
    type: 'default',
    value: 'default',
};
export var defaultSortByOptions = {
    sortBy: defaultSortBy,
    ascendingOrder: false,
};
export var defaultSortConfigs = {
    Name: {
        sortBy: sortByMap.Name,
        ascendingOrder: true,
        page: 1,
    },
    Email: {
        sortBy: sortByMap.Email,
        ascendingOrder: true,
        page: 1,
    },
    Phone: {
        sortBy: sortByMap.Phone,
        ascendingOrder: true,
        page: 1,
    },
    Role: {
        sortBy: sortByMap.Role,
        ascendingOrder: true,
        page: 1,
    },
    Status: {
        sortBy: sortByMap.Status,
        ascendingOrder: true,
        page: 1,
    },
    'Date Added': {
        sortBy: sortByMap['Date Added'],
        ascendingOrder: false,
        page: 1,
    },
};
// eslint-disable-next-line no-shadow
export var TPhaLocType;
(function (TPhaLocType) {
    TPhaLocType["SHOP"] = "SHOP";
    TPhaLocType["PROJECT"] = "PROJECT";
})(TPhaLocType || (TPhaLocType = {}));
// eslint-disable-next-line no-shadow
export var T2CStatus;
(function (T2CStatus) {
    T2CStatus["ENROLLED"] = "ENROLLED";
    T2CStatus["PENDING"] = "PENDING";
})(T2CStatus || (T2CStatus = {}));
